import * as yup from 'yup';
import { regexExp } from '@business/rules/regex';

const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$%^&*!]).{9,}$/;
const commonWords = ['password', 'mykinship', '123456', 'qwerty'];

export const signUpSchema = yup.object().shape({
  firstName: yup
    .string()
    .trim()
    .required('First Name is required')
    .min(2, 'First Name must be at least 2 characters long')
    .max(100, 'First Name cannot exceed 100 characters')
    .matches(regexExp.nameRegex, 'First Name contains invalid characters'),

  lastName: yup
    .string()
    .trim()
    .required('Last Name is required')
    .min(2, 'Last Name must be at least 2 characters long')
    .max(100, 'Last Name cannot exceed 100 characters')
    .matches(regexExp.nameRegex, 'Last Name contains invalid characters'),

  email: yup
    .string()
    .trim()
    .required('Email is required')
    .email('Invalid email address')
    .matches(regexExp.emailRegex, 'Email is not valid'),

  password: yup
    .string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters long')
    .matches(
      passwordRegex,
      'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
    )
    .notOneOf(
      commonWords,
      'Password cannot be a common word like "password", "mykinship", or "123456"'
    ),

  subscribeNewsletter: yup.boolean().optional(),

  agreeTerms: yup.boolean()
});
